import '@/assets/jquery/jquery-ajax-blob-arraybuffer'
import saveAs from 'file-saver'

var isDevEnv = process.env.NODE_ENV == "development";

var services = {
    // SERVICE_END_POINT: isDevEnv ? 'http://localhost/EPS.TSC.API/' : '/TSC/Service',
    // TOKEN_END_POINT: isDevEnv ? 'http://localhost/EPS.TSC.API/api/token/auth' : '/TSC/Service/api/token/auth',
    // API_END_POINT: isDevEnv ? 'http://localhost/EPS.TSC.API/api/' : '/TSC/Service/api/',
    // REPORT_END_POINT: isDevEnv ? 'http://localhost/EPS.TSC.Report/ReportViewer/' : '/TSC/Report/ReportViewer/',
    // clientId: 'TSC',
    SERVICE_END_POINT: config.SERVICE_END_POINT,
    TOKEN_END_POINT: config.TOKEN_END_POINT,
    API_END_POINT: config.API_END_POINT,
    clientId: 'TSC',
    clientSecret: 'b0udcdl8k80cqiyt63uq',
    getAccessToken: function () {
        return JSON.parse(localStorage.getItem("_accessToken"));
    },
    setAccessToken: function (token) {
        return localStorage.setItem("_accessToken", JSON.stringify(token));
    },
    clearAccessToken: function () {
        localStorage.removeItem("_accessToken");
    },
    getAjaxOptions: function () {
        var option = {
            //dataType: "json",
            contentType: 'application/json',//"application/x-www-form-urlencoded",
            cache: false,
            crossDomain: true,
            async: true,
            timeout: 600000
        };

        if (this.getAccessToken()) {
            option.headers = {
                'Authorization': 'Bearer ' + this.getAccessToken().access_token
            };
        }

        return option;
    },
    getOption() {
        return {
            'authorization': 'Bearer ' + this.getAccessToken().access_token
        }
    },
    request: function (requestType, url, data, options) {
        var self = this;
        var showErrorMsg = true;

        // check token expiration
        var token = self.getAccessToken();

        if (token) {
            if (new Date(token['expires']) <= new Date() && token.refresh_token) {
                this.refreshToken(token.refresh_token);
            }
        }

        var ajaxOptions = self.getAjaxOptions(data);

        if (url.indexOf('http') != 0) {
            url = this.API_END_POINT + url;
        }

        ajaxOptions.async = true;
        ajaxOptions.url = url;
        ajaxOptions.type = requestType;
        if (options) $.extend(ajaxOptions, options);

        if (ajaxOptions.type.toUpperCase() == 'GET') {
            ajaxOptions.data = data;
        } else if (ajaxOptions.contentType == 'application/json') {
            ajaxOptions.data = data ? JSON.stringify(data) : null;
        }

        return $.ajax(ajaxOptions)
            .always(function () {
            })
            .fail(function (error) {
                if (error.statusText == "timeout") {
                    if (showErrorMsg) {
                        alert.error('Operation timeout. Please try again later.');
                    }
                    console.log("Operation timeout. " + url);
                } else {
                    if (showErrorMsg) {
                        if (error.responseJSON) {
                            alert(error.responseJSON.ExceptionMessage || error.responseJSON.Message || error.responseJSON.error
                                || (typeof (error.responseJSON) == "string" ? error.responseJSON : JSON.stringify(error.responseJSON)));
                            console.log(error.responseJSON);
                        } else if (error.responseText) {
                            alert(error.responseText);
                        }
                    }
                }
            });
    },
    get: function (url, data, options) {
        return this.request('GET', url, data, options);
    },
    post: function (url, data, options) {
        return this.request('POST', url, data, options);
    },
    put: function (url, data, options) {
        return this.request('PUT', url, data, options);
    },
    delete: function (url, options) {
        return this.request('DELETE', url, null, options);
    },
    // services
    login: function (username, password) {
        var self = this;
        var data = {
            username: username,
            password: password,
            grant_type: 'password',
            client_id: this.clientId,
            client_secret: this.clientSecret
        };

        return $.ajax({
            type: 'POST',
            async: true,
            data: JSON.stringify(data),
            url: this.TOKEN_END_POINT,
            contentType: "application/json",
            dataType: 'Json',
            crossDomain: true,
            timeout: 300000
        }).done(function (token) {
            self.setAccessToken(token);
        });
    },
    refreshToken: function (refreshToken) {
        var self = this;
        // remove current access token
        self.clearAccessToken();

        // refresh the access token
        var data = {
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            client_id: this.clientId,
            client_secret: this.clientSecret
        };

        return $.ajax({
            type: 'POST',
            async: false,
            data: JSON.stringify(data),
            url: this.TOKEN_END_POINT,
            contentType: "application/json",
            dataType: 'Json',
            crossDomain: true,
            timeout: 300000
        }).done(function (token) {
            self.setAccessToken(token);
        });
    },
    logout: function () {
        var self = this;

        var accessToken = this.getAccessToken();

        // refresh the access token
        var data = {
            grant_type: 'invalidate_token',
            refresh_token: accessToken.refresh_token,
            client_id: this.clientId,
            client_secret: this.clientSecret
        };

        self.clearAccessToken();
        //return $.ajax({
        //    type: 'POST',
        //    async: true,
        //    data: data,
        //    url: this.TOKEN_END_POINT,
        //    contentType: "application/x-www-form-urlencoded",
        //    //dataType: 'Json',
        //    crossDomain: true,
        //    timeout: 300000
        //}).done(function (token) {
        //});
    },
    //upload: function (formdata) {
    //    return this.post(`${this.API_END_POINT}file`, formdata, true, {
    //        processData: false,
    //        contentType: false,
    //        enctype: 'multipart/form-data',
    //    });
    //},
    upload: function (url, formData) {
        var data = this.getFormData(formData);
        return this.post(url, null, {
            enctype: 'multipart/form-data',
            data: data,
            processData: false,
            contentType: false,
        })
    },
    getResourceUrl: function (path) {
        return this.SERVICE_END_POINT;
    },
    getUploadResourceUrl: function (path) {
        if (path) {
            return this.SERVICE_END_POINT + "/" + this.UPLOADEDCALLS_FOLDER + "/" + path.substring(this.EMAS_UPLOADEDCALLS_FOLDER.length);
        } else {
            return '';
        }
    },
    encodeURIComponent: function (obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    },
    downloadCall: function (callId) {
        return this.get(`Call/DownloadAudio?Id=${callId}`, null, true, {
            contentType: 'application/octet-stream',
            dataType: 'arraybuffer'
        }).done(function (data, textStatus, jqXHR) {
            var blob = new Blob(
                [data],
                { type: jqXHR.getResponseHeader('content-type') }
            );
            saveAs(blob, jqXHR.getResponseHeader('Filename'));
        });
    },
    downloadCsv: function (url, params) {
        return this.get(url, params, true, {
            contentType: 'application/csv',
            dataType: 'arraybuffer'
        }).done(function (data, textStatus, jqXHR) {
            var blob = new Blob(
                [data],
                { type: jqXHR.getResponseHeader('content-type') }
            );
            saveAs(blob, jqXHR.getResponseHeader('Filename'));
        });
    },
    download: function (url, contentType) {
        return this.get(url, null, {
            contentType: 'application/octet-stream; charset=UTF-8',
            dataType: 'arraybuffer'
        }).done(function (data, textStatus, xhr) {
            var blob = new Blob(
                [data],
                { type: xhr.getResponseHeader('content-type') }
            );
            var fileName = xhr.getResponseHeader('Filename');
            saveAs(blob, decodeURIComponent(escape(fileName)));
        });
    },
    getFormData(object) {
        const formData = new FormData();
        Object.keys(object).forEach(key => {
            if (object[key] != null) {
                if (Array.isArray(object[key]) && key !== "files") {
                    object[key].forEach((item, index) => {
                        formData.append(`${key}[${index}]`, item);
                    });
                } else if (key === "files") {
                    for (var i = 0; i < object[key].length; i++) {
                        formData.append(key, object[key][i]);
                    }
                } else {
                    formData.append(key, object[key]);
                }
            }
        });
        return formData;
    },
    getFormDataOld(object) {
        const formData = new FormData();
        Object.keys(object).forEach(key => {
            if (object[key] != null) {
                formData.append(key, object[key])
            }
            if (key == "files") {
                for (var i = 0; i < object[key].length; i++) {
                    formData.append(key, object[key][i]);
                }
            }
        });
        return formData;
    },
};
export default services;
